import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import {
  CertCheckState,
  TermsAgreeState,
  MvmoTermsState,
  MvnoCheckValue,
  RecoilStateList,
  TimeoutState,
  TransIdState,
} from 'src/recoil/ui'
import { useModal } from './useModal'
import useAPI from './useAPI'
import { JoinTermsDetail } from 'src/types/type'
import {showMaintenanceAlert} from "src/utils/maintenance";

const useSubmit = (pCode: string) => {
  const [mvnoCheckValue, setMvnoCheckValue] = useRecoilState(MvnoCheckValue)
  const [certCheck, setCertCheck] = useRecoilState(CertCheckState)
  const setTermsAgree = useSetRecoilState(TermsAgreeState)
  const setTranId = useSetRecoilState(TransIdState)
  const setTimeoutState = useSetRecoilState(TimeoutState)
  const ResetTimeOut = useResetRecoilState(TimeoutState)
  const { TelType, PhoneNum, CertNum, AllTermsAgree, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const setMvnoTerms = useSetRecoilState(MvmoTermsState)

  const { isOpen, toggle } = useModal()
  const { mutateAsync: CheckMvmoSubmit } = useAPI('CheckMvnoMember').useSetMutation({
    TeleType: TelType.toString(),
    PNumber: PhoneNum,
  })

  const openDeeplink = () => {
    window.location.href =
      'https://datauniverse.page.link/?link=https://partner.antiscam.co.kr/install/page_app_install&apn=com.datauniverse.antiscam&isi=1452978615&ibi=kr.co.datauniverse.antiscam'
    setTimeout(() => {
      window.close()
    }, 2000)
  }
  const termsStatus = () => {
    // 필수 약관 체크
    let arrCopy = [...termsAgree]
    if (!AllTermsAgree) {
      if (
        window.confirm(
          '서비스 이용을 위하여 약관동의가 필요합니다.\n모두(선택약관 미동의) 동의하시겠습니까?',
        )
      ) {
        TermsData.Terms.forEach((value: JoinTermsDetail) => {
          if (value.Order !== undefined)
            arrCopy[value.Order - 1] = value.Required ?? 0
        })
        setTermsAgree(arrCopy)
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }
  const setTermsAgree9th = async (flag: number) => {
    if (TelType === 1 && mvnoCheckValue) {
      await new Promise((resolve) => {
        setTermsAgree((prev) => {
          const termsAgreeCopy = [...prev]
          termsAgreeCopy[8] = flag
          resolve(termsAgreeCopy)
          return termsAgreeCopy
        })
      })
    }
  }

  const validationCert = (query: any) => {
    //MVNO KT 약관 체크 로직
    showMaintenanceAlert()
    if (PhoneNum.length !== 11) {
      alert('휴대폰번호를 정확하게 입력하여 주십시오.')
      return false
    }
    if (certCheck) {
      if (!window.confirm('인증번호 전송 내역이 존재합니다. \n재전송 하시겠습니까?')) {
        return false
      }
    }
    if (termsStatus()) {
      setMvnoCheckValue(false)
      if (TelType === 1) {
        CheckMvmoSubmit().then((data: any) => {
          if (data.Body.Type === 1) {
            setMvnoTerms({ Terms: data.Body.Terms, TermsTitle: 'KT MVNO<br/>제3자제공' })
            toggle()
          } else cert(query)
        })
      } else cert(query)
    }
  }
  const cert = async (query: any) => {
    //전화번호 인증
    await query()
      .then(async (data: any) => {
        if (data?.Header?.ErrCode === 0) {
          setCertCheck(false)
          await setTimeoutState(data?.Body?.TimeOut)
          setTranId(data?.Body?.TransactionID)
          setCertCheck(true)
          alert('입력하신 번호로 인증번호가 전송되었습니다. \n전송된 인증번호를 입력하여 주세요.')
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'complete_sms' })
          return true
        } else if (data?.Header?.ErrCode === 100403) {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'already_signup' })
          openDeeplink()
          return false
        }
      })
      .catch((error: any) => {
        console.error(error)
        return false
      })
    return false
  }
  const join = async (query: any) => {
    switch (true) {
      case PhoneNum === '':
        alert('휴대폰번호를 입력하여 주세요.')
        return false
      case TransId === '':
        alert('인증번호 받기를 먼저 시도하여 주세요.')
        return false
      case CertNum.length !== 4:
        alert('인증번호를 입력하여 주세요.')
        return false
      default:
    }
    if (termsStatus()) {
      await setTermsAgree9th(1)
      query()
        .then((data: any) => {
          if (data?.Header?.ErrCode === 0) {
            if (TelType === 2) {
              alert(
                '스마트피싱보호 안내\n휴대폰을 통해 발생하는 보이스피싱, 스미싱 등 금융 사기 피해로부터 안전하게 보호 받을 수 있는 안심 유료부가서비스에 가입되셨습니다. 원활한 이용을 위해 [확인] 버튼을 눌러 앱스토어로 이동하세요.',
              )
            } else {
              alert("서비스 가입이 완료되었습니다. '확인'버튼을 누르시면, 앱스토어로 이동합니다.")
            }
            setCertCheck(false)
            ResetTimeOut()
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ event: 'complete_signup' })
            openDeeplink()
          } else {
            setTermsAgree9th(0)
            return false
          }
        })
        .catch((error: any) => {
          return error
        })
    }
  }
  return {
    cert,
    join,
    validationCert,
    isOpen,
    toggle,
  }
}
export default useSubmit
